<template>
  <div v-if="showMode" class="addLayerClass dy3dDialog">
    <div class="headerClass">
      <span class="title">添加临时图斑</span>
      <span @click="close()">
        <a-icon type="close" style="color: aliceblue; cursor: pointer"/>
      </span>
    </div>

    <a-divider class="divider"></a-divider>

    <div class="contentInfo">
      <div class="formInfo">
        <a-form-model ref="form" :model="queryParam">
          <a-row>
            <a-col :md="24" :sm="24" v-if="!isArray">
              <a-form-model-item
                required
                prop="dataName"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="临时图斑名称">
                <a-input v-model="queryParam.dataName"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24" v-else>
              <a-form-model-item
                prop="dataName"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="临时图斑名称">
                <a-input
                  v-model="queryParam.dataName"
                  :disabled="true">
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24" style="margin-top: 8px">
              <a-form-model-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="文件夹">
                <a-tree-select
                  style="width: 100%"
                  class="treeSelect"
                  :value="queryParam.dirBsm"
                  :getPopupContainer="prpupContainer"
                  :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                  :tree-data="dirList"
                  :replaceFields="replaceFields"
                  :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
                  @change="selectDir">
                </a-tree-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <a-divider class="divider"></a-divider>
      <div class="btnsClass">
        <a-button type="link" @click="cancel" class="cancelBtn">取消</a-button>
        <a-button type="link" @click="save" class="confirmBtn">确定</a-button>
      </div>
    </div>
  </div>
</template>
  
<script>
  // import { postHeadersAction_ds } from "../../../../api/manage";
  import { mapGetters } from "vuex";
  export default {
    name: "addLayerDialog",
    data() {
      return {
        showMode: false,
        queryParam: {
          dirBsm: null,
          dataName: null,
        },
        layer: {},
        layerArry: [],
        isArray: null,
        // dirList: [],
        replaceFields: {
          children: "children",
          title: "dirName",
          key: "bsm",
          value: "bsm",
        },
        treeDefaultExpandedKeys: [],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 9 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 },
        },
        hturl: {
          // 获取文件夹树结构
          getDirList: "/zcqc.wdsc/sys-sc-gis/getSysScGisDir",
          // 保存图斑
          saveLayer: "/zcqc.wdsc/sys-sc-gis/saveSysScGisDetail",
        },
        file: null,
      };
    },
    props: {
      // 选择的图层bsm
      selectLayerBsm: {
        type: String,
        default: "",
      },
      // 弹框标题
      dialogTitle: {
        type: String,
        default: "",
      },
      myCollectionTreeData:{
        type: Array,
        default: () => [],
      }
    },
    // mounted () {
    //   this.$bus.$on('closeSaveLayerDialog',() => {
    //     this.close();
    //   });
    // },
    // beforeDestroy () {
    //   this.$bus.$off('closeSaveLayerDialog')
    // },
    methods: {
      // 获取当前用户信息
      ...mapGetters(["userInfo"]),
      // 关闭
      close() {
        this.$bus.$off('closeSaveLayerDialog')
        this.showMode = false;
      },
      /**
       * 初始化弹框信息
       * @param {*} msg 保存的图斑信息（数组或对象）
       */
      setMap(msg, dialogPositionRight) {
        console.log("msg", msg);
        this.showMode = true;
        this.$nextTick(() => {
          let dialogEle = document.querySelector(".addLayerClass");
          if (dialogPositionRight) {
            dialogEle.style.right = dialogPositionRight;
          } else {
            dialogEle.style.right = "100%";
          }
        });
        this.isArray = Array.isArray(msg);
        if (this.isArray) {
          msg.map((item) => {
            item.layerBsm = this.selectLayerBsm;
          });
          this.layerArry = msg;
          this.queryParam.dataName = null;
        } else {
          this.queryParam.dataName = msg.name;
          this.layer = msg;
          this.layer.layerBsm = this.selectLayerBsm;
        }
        this.dirList = this.myCollectionTreeData.filter(e => e.key == '2')[0].data
        this.dirList.unshift({ dirName: "无", bsm: "0", children: [] });
        this.$bus.$on('closeSaveLayerDialog',() => {
          this.close();
        });
        // this.interDirList();
      },
      //  查询文件夹树方法
      interDirList() {
        let params = {};
        params.username = this.userInfo().realname;
        params.dirType = "2";
        postHeadersAction_ds(this.hturl.getDirList, params, null)
          .then((res) => {
            // postHeadersAction_ds(this.getDirListUrl, params,null).then((res) => {
            if (res.code == 0) {
              this.dirList = res.data;
              this.dirList.unshift({ dirName: "无", bsm: "0", children: [] });
            } else {
              this.$message.warning(res.msg);
            }
          })
          .finally(() => {});
      },
      // 取消
      cancel() {
        this.close();
      },
      // 保存
      save() {
        // 触发表单验证
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.isArray) {
              // 批量保存
              let obj = {
                queryParam:this.queryParam,
                layerArry:this.layerArry,
                dataFrom:this.dialogTitle,
                wjtpye:'2',
              }
              this.$emit('analysisSaveFw',obj)
              return
              for (var item of this.layerArry) {
                let formData = new FormData();
                let dirBsm = this.queryParam.dirBsm
                  ? this.queryParam.dirBsm
                  : "0";
                formData.append("file", item.file);
                formData.append("dataFrom", this.dialogTitle);
                formData.append("dataName", item.name);
                formData.append("dirBsm", dirBsm);
                formData.append("dataContent", JSON.stringify(item));
                formData.append("uname", this.userInfo().realname);
                formData.append("wjtpye", "2");
                this.saveData(formData);
              }
            } else {
              // 表格行的保存
              let obj = {
                queryParam:this.queryParam,
                layer:this.layer,
                wjtpye:'2',
              }
              this.$emit('analysisSaveFw',obj)
              return
              let formData = new FormData();
              let dirBsm = this.queryParam.dirBsm ? this.queryParam.dirBsm : "0";
              if (this.queryParam.dataName) {
                this.layer.name = this.queryParam.dataName;
              }
              formData.append("file", this.layer.file);
              formData.append("dataFrom", this.layer.dataFrom);
              formData.append("dataName", this.queryParam.dataName);
              formData.append("dirBsm", dirBsm);
              formData.append("dataContent", JSON.stringify(this.layer));
              formData.append("uname", this.userInfo().realname);
              formData.append("wjtpye", "2");
              this.saveData(formData);
            }
          } else {
            this.$message.error("缺少必填数据!");
            return false;
          }
        });
      },
      // 调用保存接口
      saveData(formData) {
        let config = {
          headers: { "Content-Type": "multipart/form-data", ds: Date.now() },
        };
        postHeadersAction_ds(
          this.hturl.saveLayer,
          formData,
          Date.now(),
          config
        ).then((res) => {
          // postHeadersAction_ds(this.saveLayerUrl, formData, Date.now(), config).then((res) => {
          if (res.success == false) {
            this.$message.error(res.message);
          } else {
            this.$message.success("图斑保存成功!");
            this.close();
          }
        });
      },
      // 文件夹选择方法
      selectDir(val) {
        this.queryParam.dirBsm = val;
      },
      prpupContainer() {
        return document.querySelector(".ant-modal-body,.addLayerClass"); // ID是页面滚动的那个ID，根据自己来
      },
    },
  };
</script>
  
<style lang="less" scoped>
/**infoview浮动面板*/
.addLayerClass {
  position: absolute;
  top: 20%;
  width: 360px;
  max-width: 360px;
  right: 100%;
  border-radius: 4px;
  color: #ffffff;
  .headerClass {
    width: 100%;
    height: 40px;
    opacity: 0.8;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    padding-block: 0;
    display: flex;
    justify-content: space-between;
  }
  .contentInfo {
    width: 100%;
    height: 200px;
    .formInfo {
      width: 100%;
      height: 82%;
      padding-left: 10px;
      .treeSelect {
        width: 100% !important;
      }
    }
    .btnsClass {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .cancelBtn {
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}
.infoview-left {
  right: auto;
  left: 10px;
}

.addLayerClass input,
.addLayerClass select,
.addLayerClass textarea {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.5);
  font-size: 14px;
}
/deep/ .ant-row.ant-form-item {
  margin-bottom: 0px;
  // 不要校验提示
  .ant-form-explain {
    display: none;
  }
}
/deep/ .ant-divider-horizontal {
  min-width: 94%;
  width: 94%;
  margin: auto !important;
}
</style>